var ViewModelWithLoadingEvents = function () {
    var that = this;

    that.IsLoading = ko.observable(false);
    that.IsLoaded = ko.observable(false);
    that.IsSaving = ko.observable(false);
    that.IsSaved = ko.observable(false);

    that.HandleLoadEvent = function (promise) {
        that.IsLoading(true);
        promise.done(function (data) {
            if (data.Success) {
                that.IsLoaded(true);
            }
        }).fail(function () {
            alerts.error();
        }).always(function () {
            that.IsLoading(false);
        });
    };

    that.HandleSaveEvent = function (promise) {
        that.IsSaving(true);
        promise.done(function (data) {
            if (data.Success) {
                that.IsSaved(true);
            }
        }).fail(function () {
            alerts.error();
        }).always(function () {
            that.IsSaving(false);
        });
    };
};
